import { alpha } from '@mui/material/styles';

/**
 * Approximate Apple's "Liquid Glass" chrome for the web:
 * translucent fill, heavy blur, specular edge, soft ambient shadow.
 * Applied only to mobile chrome (header / tab bar / More sheet).
 */
export const liquidGlassSx = (theme, { radius = 0, border = 'top' } = {}) => {
  const highlight =
    border === 'all'
      ? `1px solid ${alpha('#FFFFFF', 0.55)}`
      : undefined;

  return {
    backgroundColor: alpha(theme.palette.background.paper, 0.52),
    backgroundImage: `linear-gradient(
      180deg,
      ${alpha('#FFFFFF', 0.55)} 0%,
      ${alpha('#FFFFFF', 0.12)} 40%,
      ${alpha('#FFFFFF', 0.02)} 100%
    )`,
    backdropFilter: 'saturate(190%) blur(28px)',
    WebkitBackdropFilter: 'saturate(190%) blur(28px)',
    borderRadius: radius,
    border: highlight,
    borderTop: border === 'top' ? `1px solid ${alpha('#FFFFFF', 0.5)}` : undefined,
    boxShadow: `
      0 10px 40px ${alpha(theme.palette.grey[900], 0.12)},
      0 1px 0 ${alpha('#FFFFFF', 0.65)} inset,
      0 -1px 0 ${alpha(theme.palette.grey[500], 0.12)} inset
    `,
    // Keep text crisp over the frosted layer.
    color: theme.palette.text.primary,
  };
};

export const MOBILE_TAB_BAR_HEIGHT = 62;
export const MOBILE_TAB_BAR_MARGIN = 10;
// Space Main needs so content clears the floating glass pill.
export const MOBILE_BOTTOM_NAV_HEIGHT = MOBILE_TAB_BAR_HEIGHT + MOBILE_TAB_BAR_MARGIN + 4;
